import { render, staticRenderFns } from "./ServicosOnLine.vue?vue&type=template&id=9364efd0&"
import script from "./ServicosOnLine.vue?vue&type=script&lang=js&"
export * from "./ServicosOnLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports